export const hairColourOptions = [
  "Black",
  "Light Brown",
  "Dark Brown",
  "Blonde",
  "Ginger/Red",
  "Grey",
  "White",
  "Other",
];

export const infectionOptions = [
  "Hepatitis A",
  "Hepatitis B",
  "Hepatitis C",
  "HIV/AIDS",
  "Other",
  "No",
  "Prefer not to say",
];
